// Build an SMS link that opens the user's native messaging app with the
// owner's number pre-selected and a booking template pre-filled.
//
// Works on iPhone, Android, Mac (Messages app) and Windows Phone Link.
// On platforms without a messaging app the browser will simply ignore the
// `sms:` scheme. for that case the calling component falls back to the
// in-page #contact form.

export const BOOKING_SMS_NUMBER = "+16476467223";

export const BOOKING_SMS_TEMPLATE = `Hi Jester Werks. I'd like to book a coating.

• Name: 
• Vehicle (year / make / model / colour): 
• Service: Full Ceramic ($550) / Paint Correction ($275) / Other
• Drop-off city: Mississauga / Vaughan / Other
• Timeline: ASAP / This week / This month / Flexible
• Best time to call back: 

(Sent from ceramiccoatingmississauga.com)`;

export function buildBookingSmsHref({
  number = BOOKING_SMS_NUMBER,
  body = BOOKING_SMS_TEMPLATE,
} = {}) {
  // `?&body=` is the broadly compatible separator that works on both
  // iOS (which traditionally used `&`) and Android (which uses `?`).
  return `sms:${number}?&body=${encodeURIComponent(body)}`;
}
